import { render, staticRenderFns } from "./d-root-medicine-order-details.vue?vue&type=template&id=4b782c12"
import script from "./d-root-medicine-order-details.vue?vue&type=script&lang=js"
export * from "./d-root-medicine-order-details.vue?vue&type=script&lang=js"
import style0 from "./d-root-medicine-order-details.vue?vue&type=style&index=0&id=4b782c12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports